import { getTopDockingHeight, getBottomDockingHeight } from './getDockingHeight';
var DEFAULT_MIN_BODY_HEIGHT = 100;
export default function createDockingViewState(isRibbonShown, isInlineCompose, isStickyDockingEnabled, isPopout) {
    return {
        isTopDocking: false,
        isBottomDocking: false,
        topDockingHeight: getTopDockingHeight(isInlineCompose),
        bottomDockingHeight: getBottomDockingHeight(isRibbonShown, isInlineCompose),
        minBodyHeight: DEFAULT_MIN_BODY_HEIGHT,
        scrollLeft: 0,
        scrollBarHeight: 0,
        dockingWidth: 0,
        bottomDockingBottom: 0,
        useStickyDocking: isStickyDockingEnabled && browserSupportSticky(),
        isPopout: isPopout,
    };
}
var supportSticky = null;
function browserSupportSticky() {
    if (!supportSticky) {
        supportSticky = {
            value: cssPropertyValueSupported('position', 'sticky') &&
                typeof IntersectionObserver == 'function',
        };
    }
    return supportSticky.value;
}
function cssPropertyValueSupported(prop, value) {
    var d = document.createElement('div');
    d.style[prop] = value;
    return d.style[prop] === value;
}
//# sourceMappingURL=createDockingViewState.js.map